import { render, staticRenderFns } from "./produtosMaisVendidos.vue?vue&type=template&id=27f21cbc"
import script from "./produtosMaisVendidos.ts?vue&type=script&lang=js&external"
export * from "./produtosMaisVendidos.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27f21cbc')) {
      api.createRecord('27f21cbc', component.options)
    } else {
      api.reload('27f21cbc', component.options)
    }
    module.hot.accept("./produtosMaisVendidos.vue?vue&type=template&id=27f21cbc", function () {
      api.rerender('27f21cbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/dashboard/produtosMaisVendidos.vue"
export default component.exports